import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTrash, HiOutlineXMark } from 'react-icons/hi2';

const WorkOrderStep5Resources = ({ formData, setFormData, formErrors, users, spareParts, tools, ppeList }) => {
  const [newSparePart, setNewSparePart] = useState({ partId: '', quantity: '', cost: '' });
  const [newTool, setNewTool] = useState('');
  const [newPPE, setNewPPE] = useState('');

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'select-multiple') {
      const selectedOptions = Array.from(e.target.selectedOptions, option => parseInt(option.value, 10));
      setFormData(prev => ({
        ...prev,
        [name]: selectedOptions
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const addSparePart = () => {
    if (newSparePart.partId && newSparePart.quantity) {
      const part = spareParts.find(p => p.sparePartId === parseInt(newSparePart.partId, 10));
      setFormData(prev => ({
        ...prev,
        spareParts: [...prev.spareParts, {
          partId: parseInt(newSparePart.partId, 10),
          partName: part?.partName || '',
          quantity: parseFloat(newSparePart.quantity),
          cost: parseFloat(newSparePart.cost) || 0
        }]
      }));
      setNewSparePart({ partId: '', quantity: '', cost: '' });
    }
  };

  const removeSparePart = (index) => {
    setFormData(prev => ({
      ...prev,
      spareParts: prev.spareParts.filter((_, i) => i !== index)
    }));
  };

  const addTool = () => {
    if (newTool) {
      setFormData(prev => ({
        ...prev,
        toolsRequired: [...prev.toolsRequired, parseInt(newTool, 10)]
      }));
      setNewTool('');
    }
  };

  const removeTool = (toolId) => {
    setFormData(prev => ({
      ...prev,
      toolsRequired: prev.toolsRequired.filter(id => id !== toolId)
    }));
  };

  const addPPE = () => {
    if (newPPE) {
      setFormData(prev => ({
        ...prev,
        ppeRequired: [...prev.ppeRequired, parseInt(newPPE, 10)]
      }));
      setNewPPE('');
    }
  };

  const removePPE = (ppeId) => {
    setFormData(prev => ({
      ...prev,
      ppeRequired: prev.ppeRequired.filter(id => id !== ppeId)
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Resources</h3>
        <div className='row btmbrder'>
          <div className="form-group col-md-6">
            <label htmlFor="assignedTechnicianIds">Assigned Technician(s)</label>
            <div className="form-row">
              <div className="form-group" style={{ flex: 1 }}>
                <select
                  id="assignedTechnicianIds"
                  name="assignedTechnicianIds"
                  value=""
                  onChange={(e) => {
                    const selectedId = parseInt(e.target.value, 10);
                    if (selectedId && !formData.assignedTechnicianIds.includes(selectedId)) {
                      setFormData(prev => ({
                        ...prev,
                        assignedTechnicianIds: [...prev.assignedTechnicianIds, selectedId]
                      }));
                    }
                    e.target.value = ''; // Reset dropdown
                  }}
                >
                  <option value="">Select Technician</option>
                  {users
                    .filter(user => !formData.assignedTechnicianIds.includes(user.userId))
                    .map(user => (
                      <option key={user.userId} value={user.userId}>
                        {user.fullName}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {formData.assignedTechnicianIds.length > 0 && (
              <div className="technicians-list" style={{ marginTop: '0rem' }}>
                <div className='listBox'>
                  {formData.assignedTechnicianIds.map(technicianId => {
                    const technician = users.find(u => u.userId === technicianId);
                    return (
                      <div key={technicianId} className="list-item itemgreen" >
                        <span>{technician?.fullName || `Technician ${technicianId}`}</span>
                        <button type="button" className="btn-icon" onClick={() => {
                          setFormData(prev => ({
                            ...prev,
                            assignedTechnicianIds: prev.assignedTechnicianIds.filter(id => id !== technicianId)
                          }));
                        }}>
                          <HiOutlineXMark />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="skillCategory">Skill Category</label>
            <select
              id="skillCategory"
              name="skillCategory"
              value={formData.skillCategory}
              onChange={handleChange}
            >
              <option value="">Select Skill Category</option>
              <option value="Mechanical">Mechanical</option>
              <option value="Electrical">Electrical</option>
              <option value="Instrumentation">Instrumentation</option>
            </select>
          </div>
        </div>

        <div className="row btmbrder">
          <div className="form-section col-md-12">
            <h4 className="section-title" style={{ fontSize: '1rem' }}>Spare Parts</h4>
            <div className="form-row">
              <div className="form-group">
                <select
                  value={newSparePart.partId}
                  onChange={(e) => setNewSparePart({ ...newSparePart, partId: e.target.value })}
                >
                  <option value="">Select Part</option>
                  {spareParts.map(part => (
                    <option key={part.sparePartId} value={part.sparePartId}>
                      {part.partName} ({part.partNumber}) - Stock: {part.currentStock || 0}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <input
                  type="number"
                  placeholder="Quantity"
                  value={newSparePart.quantity}
                  onChange={(e) => setNewSparePart({ ...newSparePart, quantity: e.target.value })}
                  step="1"
                  min="0"
                />
              </div>
              <div className="form-group">
                <input
                  type="number"
                  placeholder="Cost"
                  value={newSparePart.cost}
                  onChange={(e) => setNewSparePart({ ...newSparePart, cost: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <button type="button" className="btn-primary btnh44" onClick={addSparePart}>
                  <HiOutlinePlus /> Add
                </button>
              </div>
            </div>
            {formData.spareParts.length > 0 && (
              <div className="table-responsive" style={{ marginTop: '0rem', maxWidth: '60%', border: '1px solid var(--border-color)', borderRadius: '8px', overflow: 'hidden' }}>
                <table className="data-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 0 }}>
                  <thead style={{ background: 'var(--surface)' }}>
                    <tr>
                      <th style={{ background: 'var(--surface)', padding: '0.75rem', fontSize: '0.75rem', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase' }}>PART NAME</th>
                      <th style={{ background: 'var(--surface)', padding: '0.75rem', fontSize: '0.75rem', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase', textAlign: 'center' }}>QTY</th>
                      <th style={{ background: 'var(--surface)', padding: '0.75rem', fontSize: '0.75rem', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase', textAlign: 'right' }}>UNIT COST</th>
                      <th style={{ background: 'var(--surface)', padding: '0.75rem', width: '50px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.spareParts.map((part, index) => {
                      const partInfo = spareParts.find(p => p.sparePartId === part.partId);
                      return (
                        <tr key={index} style={{ background: 'var(--card-bg)' }}>
                          <td>{partInfo?.partName || `Part ${part.partId}`}</td>
                          <td style={{ width: '200px', textAlign: 'center' }}>{part.quantity} pcs</td>
                          <td style={{ width: '150px', textAlign: 'right' }}>${part.cost}</td>
                          <td style={{ width: '100px', textAlign: 'center' }}>
                            <button type="button" onClick={() => removeSparePart(index)} style={{ padding: '0.25rem', color: 'var(--text-tertiary)' }}>
                              <HiOutlineXMark size={22} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div className="row btmbrder">
          <div className="form-section col-md-12">
            <h4 className="section-title" style={{ fontSize: '1rem' }}>Tools Required</h4>
            <div className="row">
              <div className="form-group col-md-6" style={{ flex: 1 }}>
                <select
                  value={newTool}
                  onChange={(e) => setNewTool(e.target.value)}
                >
                  <option value="">Select Tool</option>
                  {tools.map(tool => (
                    <option key={tool.toolId} value={tool.toolId}>
                      {tool.toolName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-6">
                <button type="button" className="btn-primary btnh44 wdth100" onClick={addTool}>
                  <HiOutlinePlus /> Add
                </button>
              </div>
            </div>
            {formData.toolsRequired.length > 0 && (
              <div className="tools-list" style={{ marginTop: '1rem' }}>
                {formData.toolsRequired.map(toolId => {
                  const tool = tools.find(t => t.toolId === toolId);
                  return (
                    <div key={toolId} className="list-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', background: 'var(--bg-secondary)', borderRadius: '6px', marginBottom: '0.5rem' }}>
                      <span>{tool?.toolName || `Tool ${toolId}`}</span>
                      <button type="button" className="btn-icon" onClick={() => removeTool(toolId)}>
                        <HiOutlineXMark />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="row btmbrder">
          <div className="form-section col-md-12">
            <h4 className="section-title" style={{ fontSize: '1rem' }}>PPE Required</h4>
            <div className="row">
              <div className="form-group col-md-6" style={{ flex: 1 }}>
                <select
                  value={newPPE}
                  onChange={(e) => setNewPPE(e.target.value)}
                >
                  <option value="">Select PPE</option>
                  {ppeList.map(ppe => (
                    <option key={ppe.ppeId} value={ppe.ppeId}>
                      {ppe.ppeName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-6">
                <button type="button" className="btn-primary btnh44 wdth100" onClick={addPPE}>
                  <HiOutlinePlus /> Add
                </button>
              </div>
            </div>
            {formData.ppeRequired.length > 0 && (

              <div className="ppe-list">
                <div className="listBox">
                  {formData.ppeRequired.map(ppeId => {
                    const ppe = ppeList.find(p => p.ppeId === ppeId);
                    return (
                      <div key={ppeId} className="list-item itemgreen" >
                        <span>{ppe?.ppeName || `PPE ${ppeId}`}</span>
                        <button type="button" className="btn-icon" onClick={() => removePPE(ppeId)}>
                          <HiOutlineXMark />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep5Resources;

